import Component from '../../classes/Component';
import {animationTargetAttr, initSectionsAnimations} from "../common/animation/helpers";

export default function () {

    return new Component({
        name: 'serviceAnimation',
        requiredTargets: `[${animationTargetAttr}^='service-']`,
        onInit() {
            initSectionsAnimations([
                {
                    name: 'service-ingredients',
                    axis: 'y'
                },
                {
                    name: 'service-software',
                    axis: 'x'
                },
                {
                    name: 'service-solution',
                    axis: 'x',
                    direction: -1
                },
                {
                    name: 'service-support',
                    axis: 'x'
                },
                {
                    name: 'service-discount',
                    axis: 'x',
                    direction: -1
                },
                {
                    name: 'service-videos',
                    axis: 'y'
                },
                // {
                //     name: 'landing-reviews',
                //     axis: 'y'
                // },
            ]);
        }
    })
}
